class PawfolioNavigation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const items = [...this.querySelectorAll('[data-nav-item]')];
    const desktop = () => this.classList.contains('pf-nav--desktop') && matchMedia('(hover: hover) and (min-width: 750px)').matches;
    const close = (except) => items.forEach(item => { if (item !== except) item.open = false; });
    const position = () => this.style.setProperty('--pf-panel-center', `${innerWidth / 2 - this.getBoundingClientRect().left}px`);
    position();
    window.addEventListener('resize', position, options);
    items.forEach(item => {
      const trigger = item.querySelector('summary');
      item.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(item.open));
        if (item.open) { position(); close(item); }
      }, options);
      trigger.setAttribute('aria-expanded', String(item.open));
      trigger.addEventListener('click', event => {
        clearTimeout(this.timer); close(item);
        // On touch screens, the first tap exposes the links; a second tap follows the category.
        if (this.classList.contains('pf-nav--desktop') && (event.pointerType === 'touch' || !matchMedia('(hover: hover)').matches) && event.target.closest('.pf-nav__destination') && !item.open) {
          event.preventDefault(); item.open = true;
        }
      }, options);
      item.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || !desktop()) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { close(item); item.open = true; }, 180);
      }, options);
      item.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch' || !desktop()) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { item.open = false; }, 260);
      }, options);
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape' && item.open) {
          event.preventDefault(); event.stopPropagation(); clearTimeout(this.timer);
          this.handledEscape = true;
          item.open = false; trigger.focus();
        }
        if (event.key === 'ArrowDown' && event.target === trigger) {
          event.preventDefault(); close(item); item.open = true; item.querySelector('.pf-nav__panel a')?.focus();
        }
      }, options);
    });
    this.addEventListener('keyup', event => { if (event.key === 'Escape' && this.handledEscape) { event.stopPropagation(); this.handledEscape = false; } }, options);
    this.addEventListener('focusout', event => { if (!matchMedia('(hover: hover)').matches) return; // Safari blurs the summary before a tapped link receives its click.
      if (!this.contains(event.relatedTarget)) { clearTimeout(this.timer); close(); } }, options);
    document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) { clearTimeout(this.timer); close(); } }, options);
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
}
if (!customElements.get('pawfolio-navigation')) customElements.define('pawfolio-navigation', PawfolioNavigation);
